import { CurrencyType, ItemType } from '@wolffun/system-currency';
import icThetanCoin from '../../assets/img/thetan_coin_V2.png';
import icBNB from '../../assets/img/bnb.png';
import icThetanGem from '../../assets/img/thetan_gem_V2.png';
import icTournamentTicket from '../../assets/img/tournament_ticket.png';
import icWBNB from '../../assets/img/wbnb.png';
import icBUSD from '../../assets/img/busd.png';
import icQuest from '../../assets/img/quest_point.png';
import gold from '../../assets/img/gold.png';
import icBUSDT from '../../assets/img/usdt.png';
export let AppError;
/**
 * Error code defined by EIP standards
 */

(function (AppError) {
  AppError[AppError["NO_ERROR"] = 0] = "NO_ERROR";
  AppError[AppError["UNNKOWN"] = -1] = "UNNKOWN";
  AppError[AppError["SERVER_ERROR"] = -2] = "SERVER_ERROR";
  AppError[AppError["REJECTED_BY_FE"] = -3] = "REJECTED_BY_FE";
  AppError[AppError["ABORTED_BY_USER"] = -4] = "ABORTED_BY_USER";
  AppError[AppError["NOT_LOGGED_IN"] = -5] = "NOT_LOGGED_IN";
  AppError[AppError["NAME_INVALID"] = -6] = "NAME_INVALID";
  AppError[AppError["MIN_CLAIM_EXCEEDED"] = -7] = "MIN_CLAIM_EXCEEDED";
  AppError[AppError["MIN_DEPOSIT_EXCEEDED"] = -8] = "MIN_DEPOSIT_EXCEEDED";
  AppError[AppError["WRONG_FLOATING_PRICE"] = -9] = "WRONG_FLOATING_PRICE";
  AppError[AppError["INVALID_OWNER"] = -10] = "INVALID_OWNER";
  AppError[AppError["INSUFFICIENT_BALANCE"] = -11] = "INSUFFICIENT_BALANCE";
  AppError[AppError["INSUFFICIENT_PRIVATE_TICKET"] = -12] = "INSUFFICIENT_PRIVATE_TICKET";
  AppError[AppError["COINBASE_WALLET_REQUIRED"] = -13] = "COINBASE_WALLET_REQUIRED";
  AppError[AppError["TOKEN_INVALID"] = 1] = "TOKEN_INVALID";
  AppError[AppError["TOKEN_EXPIRED"] = 2] = "TOKEN_EXPIRED";
  AppError[AppError["USER_NOT_FOUND"] = 3] = "USER_NOT_FOUND";
  AppError[AppError["USER_BANNED"] = 4] = "USER_BANNED";
  AppError[AppError["WRONG_FORMAT"] = 5] = "WRONG_FORMAT";
  AppError[AppError["WRONG_PRICE"] = 6] = "WRONG_PRICE";
  AppError[AppError["OUT_OF_LIMIT"] = 7] = "OUT_OF_LIMIT";
  AppError[AppError["CAN_NOT_CLAIM"] = 8] = "CAN_NOT_CLAIM";
  AppError[AppError["MAINTENANCE_CASHOUT"] = 13] = "MAINTENANCE_CASHOUT";
  AppError[AppError["QUOTE_EXPIRED"] = 14] = "QUOTE_EXPIRED";
  AppError[AppError["MISMATCH_TOKEN"] = 15] = "MISMATCH_TOKEN";
  AppError[AppError["BUSY_SERVER"] = 16] = "BUSY_SERVER";
  AppError[AppError["CLAIMED_TOKEN"] = 17] = "CLAIMED_TOKEN";
  AppError[AppError["OUT_OF_TIME"] = 19] = "OUT_OF_TIME";
  AppError[AppError["NOT_FOUND_HERO_NTF_ID"] = 404] = "NOT_FOUND_HERO_NTF_ID";
  AppError[AppError["EXPIRED_TURN"] = 100] = "EXPIRED_TURN";
  AppError[AppError["EXPIRED_SEASON"] = 101] = "EXPIRED_SEASON";
  AppError[AppError["EXPIRED_PRICE"] = 200] = "EXPIRED_PRICE";
  AppError[AppError["EMAIL_NOT_EXIST"] = 2001] = "EMAIL_NOT_EXIST";
  AppError[AppError["EMAIL_EXIST"] = 2002] = "EMAIL_EXIST";
  AppError[AppError["CODE_INVALID"] = 2003] = "CODE_INVALID";
  AppError[AppError["EMAIL_INVALID"] = 2004] = "EMAIL_INVALID";
  AppError[AppError["INCORRECT_USER_ID"] = 2005] = "INCORRECT_USER_ID";
  AppError[AppError["NOT_ENOUGH_TICKET_CHANGE_NAME"] = 2006] = "NOT_ENOUGH_TICKET_CHANGE_NAME";
  AppError[AppError["USER_NAME_HAS_TAKEN"] = 2007] = "USER_NAME_HAS_TAKEN";
  AppError[AppError["ACCOUNT_HAS_BEEN_LINKED"] = 2009] = "ACCOUNT_HAS_BEEN_LINKED";
  AppError[AppError["SIGNATURE_INVALID"] = 1100] = "SIGNATURE_INVALID";
  AppError[AppError["ADDRESS_EXIST"] = 1101] = "ADDRESS_EXIST";
  AppError[AppError["ID_INVALID"] = 3001] = "ID_INVALID";
  AppError[AppError["ADDRESS_INVALID"] = 3002] = "ADDRESS_INVALID";
  AppError[AppError["TYPE_INVALID"] = 3003] = "TYPE_INVALID";
  AppError[AppError["HERO_ID_INVALID"] = 3004] = "HERO_ID_INVALID";
  AppError[AppError["INVALIDATE"] = 3005] = "INVALIDATE";
  AppError[AppError["NOT_ENOUGH"] = 3006] = "NOT_ENOUGH";
  AppError[AppError["NOT_ENOUGH_THC"] = 3007] = "NOT_ENOUGH_THC";
  AppError[AppError["NOT_ENOUGH_THG"] = 3008] = "NOT_ENOUGH_THG";
  AppError[AppError["NOT_ENOUGH_PP"] = 3009] = "NOT_ENOUGH_PP";
  AppError[AppError["NOT_OWNER_HERO"] = 3010] = "NOT_OWNER_HERO";
  AppError[AppError["HERO_NOT_AVAILABLE"] = 3011] = "HERO_NOT_AVAILABLE";
  AppError[AppError["NOT_RANK_ENOUGH_CASHOUT"] = 3012] = "NOT_RANK_ENOUGH_CASHOUT";
  AppError[AppError["NOT_OLD_ENOUGH_CASHOUT"] = 3013] = "NOT_OLD_ENOUGH_CASHOUT";
  AppError[AppError["OUT_OF_LIMIT_CASHOUT"] = 3014] = "OUT_OF_LIMIT_CASHOUT";
  AppError[AppError["NOT_ENOUGH_GTHG"] = 3015] = "NOT_ENOUGH_GTHG";
  AppError[AppError["NOT_ENOUGH_GTHC"] = 3016] = "NOT_ENOUGH_GTHC";
  AppError[AppError["INVALID_GTHG"] = 3017] = "INVALID_GTHG";
  AppError[AppError["NOT_ENOUGH_FEE_GTHG"] = 3018] = "NOT_ENOUGH_FEE_GTHG";
  AppError[AppError["HERO_IN_THE_MATCH"] = 3019] = "HERO_IN_THE_MATCH";
  AppError[AppError["MINIMUN_CASHOUT"] = 3020] = "MINIMUN_CASHOUT";
  AppError[AppError["MAXIMUN_CASHOUT"] = 3021] = "MAXIMUN_CASHOUT";
  AppError[AppError["MAX_LEVEL_REACHED"] = 3024] = "MAX_LEVEL_REACHED";
  AppError[AppError["OUTDATED_BUYING"] = 3100] = "OUTDATED_BUYING";
  AppError[AppError["OUT_OF_BOXES"] = 3101] = "OUT_OF_BOXES";
  AppError[AppError["NOT_ENOUGH_BOX"] = 3102] = "NOT_ENOUGH_BOX";
  AppError[AppError["NOT_LINK_ACCOUNT_ID"] = 3110] = "NOT_LINK_ACCOUNT_ID";
  AppError[AppError["NOT_INSTALL_GAME"] = 3111] = "NOT_INSTALL_GAME";
  AppError[AppError["NOT_MEET_COUNT_DOWN"] = 3112] = "NOT_MEET_COUNT_DOWN";
  AppError[AppError["ALREADY_CLAIM_GIFT_BOX"] = 3113] = "ALREADY_CLAIM_GIFT_BOX";
  AppError[AppError["COINBASE_WALLET_MISSING"] = 3114] = "COINBASE_WALLET_MISSING";
  AppError[AppError["INVALID_GIFT_CODE"] = 3115] = "INVALID_GIFT_CODE";
  AppError[AppError["REQUEST_PROCESSING"] = 3116] = "REQUEST_PROCESSING";
  AppError[AppError["CHECK_GLORY_PASS"] = 3117] = "CHECK_GLORY_PASS";
  AppError[AppError["MUST_CHECK_IN_MKP"] = 3118] = "MUST_CHECK_IN_MKP";
  AppError[AppError["REQUIRE_SAMSUNG_INSTALL"] = 3119] = "REQUIRE_SAMSUNG_INSTALL";
  AppError[AppError["HERO_HAS_BEEN_RENTED"] = 3120] = "HERO_HAS_BEEN_RENTED";
  AppError[AppError["LOW_RENT_BATTLES"] = 3121] = "LOW_RENT_BATTLES";
  AppError[AppError["HIGH_RENT_BATTLES"] = 3122] = "HIGH_RENT_BATTLES";
  AppError[AppError["LOW_RENT_PRICE"] = 3123] = "LOW_RENT_PRICE";
  AppError[AppError["HIGH_RENT_PRICE"] = 3126] = "HIGH_RENT_PRICE";
  AppError[AppError["ALREADY_RENTED_OUT"] = 3124] = "ALREADY_RENTED_OUT";
  AppError[AppError["MAX_BATTLE_RENTED"] = 3125] = "MAX_BATTLE_RENTED";
  AppError[AppError["RETURNING_OWNER"] = 3127] = "RETURNING_OWNER";
  AppError[AppError["MAINTENANCE_HERO_RENTAL"] = 3128] = "MAINTENANCE_HERO_RENTAL";
  AppError[AppError["INVALID_REMAIN_GTHC_BATTLE"] = 3131] = "INVALID_REMAIN_GTHC_BATTLE";
  AppError[AppError["NOT_ENOUGHT_BATTLES"] = 3132] = "NOT_ENOUGHT_BATTLES";
  AppError[AppError["MAX_GTHG_VESTING_SAFE_CLAIMED"] = 3141] = "MAX_GTHG_VESTING_SAFE_CLAIMED";
  AppError[AppError["CONNECT_WALLET_BEFORE_EVENT"] = 3133] = "CONNECT_WALLET_BEFORE_EVENT";
  AppError[AppError["MAINTENANCE_STAKING"] = 3160] = "MAINTENANCE_STAKING";
  AppError[AppError["INVALID_STAKING_PLAN"] = 3161] = "INVALID_STAKING_PLAN";
  AppError[AppError["INVALID_STAKING_AMOUNT"] = 3162] = "INVALID_STAKING_AMOUNT";
  AppError[AppError["OUT_OF_TIME_STAKING"] = 3163] = "OUT_OF_TIME_STAKING";
  AppError[AppError["STAKING_POOL_FULLED"] = 3164] = "STAKING_POOL_FULLED";
  AppError[AppError["HERO_UNAVAILABLE"] = 3165] = "HERO_UNAVAILABLE";
  AppError[AppError["NOT_READY_TO_UNSTAKE"] = 3166] = "NOT_READY_TO_UNSTAKE";
  AppError[AppError["ALREADY_UNSTAKE"] = 3167] = "ALREADY_UNSTAKE";
  AppError[AppError["COUNTDOWN_CLAIM_REWARD"] = 3168] = "COUNTDOWN_CLAIM_REWARD";
  AppError[AppError["MAX_PENDING_STAKE"] = 3169] = "MAX_PENDING_STAKE";
  AppError[AppError["EMPTY_STAKING_REWARD"] = 3170] = "EMPTY_STAKING_REWARD";
  AppError[AppError["NOT_READY_FOR_CLAIM"] = 3171] = "NOT_READY_FOR_CLAIM";
  AppError[AppError["IS_NOT_CREATOR"] = 3151] = "IS_NOT_CREATOR";
  AppError[AppError["IS_NOT_VIEWER"] = 3152] = "IS_NOT_VIEWER";
  AppError[AppError["ALLOCATION_LIMIT_EXCEEDED"] = 3180] = "ALLOCATION_LIMIT_EXCEEDED";
  AppError[AppError["SALE_SOLD_OUT"] = 3181] = "SALE_SOLD_OUT";
  AppError[AppError["THC_RATE_CHANGED"] = 3182] = "THC_RATE_CHANGED";
  AppError[AppError["INSUFFICIENT_TICKET_BALANCE"] = 3183] = "INSUFFICIENT_TICKET_BALANCE";
  AppError[AppError["ALREADY_PURCHASED"] = 3184] = "ALREADY_PURCHASED";
  AppError[AppError["SALE_NOT_STARTED"] = 3185] = "SALE_NOT_STARTED";
  AppError[AppError["SALE_ENDED"] = 3186] = "SALE_ENDED";
  AppError[AppError["THC_RATE_EXPIRED"] = 3187] = "THC_RATE_EXPIRED";
  AppError[AppError["INVALID_PROJECT"] = 3188] = "INVALID_PROJECT";
  AppError[AppError["INSUFFICIENT_THC_BALANCE"] = 3189] = "INSUFFICIENT_THC_BALANCE";
  AppError[AppError["WRONG_SET"] = 3300] = "WRONG_SET";
  AppError[AppError["FUSING"] = 3301] = "FUSING";
  AppError[AppError["NEGATIVE_COST"] = 3302] = "NEGATIVE_COST";
  AppError[AppError["MINT_LOW_HERO_LEVEL"] = 3322] = "MINT_LOW_HERO_LEVEL";
  AppError[AppError["MINT_LOW_USER_RAKING_LEVEL"] = 3323] = "MINT_LOW_USER_RAKING_LEVEL";
  AppError[AppError["MINT_LIMIT_TIME"] = 3324] = "MINT_LIMIT_TIME";
  AppError[AppError["NOT_HAVE_NFT"] = 5000] = "NOT_HAVE_NFT";
})(AppError || (AppError = {}));

export let EipError;

(function (EipError) {
  EipError[EipError["NO_ERROR"] = 0] = "NO_ERROR";
  EipError[EipError["UNNKOWN"] = 1] = "UNNKOWN";
  EipError[EipError["METAMASK_NOT_SUPPORTED"] = 2] = "METAMASK_NOT_SUPPORTED";
  EipError[EipError["METAMASK_WRONG_CHAIN"] = 3] = "METAMASK_WRONG_CHAIN";
  EipError[EipError["METAMASK_LOCKED"] = 4] = "METAMASK_LOCKED";
  EipError[EipError["THETA_COIN_NOT_ADDED"] = 5] = "THETA_COIN_NOT_ADDED";
  EipError[EipError["NO_PROVIDER_EXIST"] = 6] = "NO_PROVIDER_EXIST";
  EipError[EipError["COINBASE_NOT_SUPPORT"] = 7] = "COINBASE_NOT_SUPPORT";
  EipError[EipError["THETAN_WALLET_NOT_SUPPORT"] = 10] = "THETAN_WALLET_NOT_SUPPORT";
  EipError[EipError["WALLET_CONNECT_NOT_SUPPORT"] = 8] = "WALLET_CONNECT_NOT_SUPPORT";
  EipError[EipError["SEQUENCE_NOT_SUPPORT"] = 9] = "SEQUENCE_NOT_SUPPORT";
  EipError[EipError["PARSE_ERROR"] = -32700] = "PARSE_ERROR";
  EipError[EipError["INVALID_REQUEST"] = -32600] = "INVALID_REQUEST";
  EipError[EipError["METHOD_NOT_FOUND"] = -32601] = "METHOD_NOT_FOUND";
  EipError[EipError["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
  EipError[EipError["INTERNAL_ERROR"] = -32603] = "INTERNAL_ERROR";
  EipError[EipError["INVALID_INPUT"] = -32000] = "INVALID_INPUT";
  EipError[EipError["RESOURCE_NOT_FOUND"] = -32001] = "RESOURCE_NOT_FOUND";
  EipError[EipError["RESOURCE_UNAVAILABLE"] = -32002] = "RESOURCE_UNAVAILABLE";
  EipError[EipError["TRANSACTION_REJECTED"] = -32003] = "TRANSACTION_REJECTED";
  EipError[EipError["METHOD_NOT_SUPPORTED"] = -32004] = "METHOD_NOT_SUPPORTED";
  EipError[EipError["LIMIT_EXCEEDED"] = -32005] = "LIMIT_EXCEEDED";
  EipError[EipError["JSON_RPC_VERSION_NOT_SUPPORTED"] = -32006] = "JSON_RPC_VERSION_NOT_SUPPORTED";
  EipError[EipError["INVALID_ADDRESS"] = 14] = "INVALID_ADDRESS";
  EipError[EipError["USER_REJECTED_REQUEST"] = 4001] = "USER_REJECTED_REQUEST";
  EipError[EipError["USER_UNAUTHORIZED"] = 4100] = "USER_UNAUTHORIZED";
  EipError[EipError["UNSUPPORTED_METHOD"] = 4200] = "UNSUPPORTED_METHOD";
  EipError[EipError["DISCONNECTED"] = 4900] = "DISCONNECTED";
  EipError[EipError["CHAIN_DISCONNECTED"] = 4901] = "CHAIN_DISCONNECTED";
  EipError[EipError["CHAIN_NOT_FOUND"] = 4902] = "CHAIN_NOT_FOUND";
  EipError[EipError["INVALID_SIGNATURE"] = 10002] = "INVALID_SIGNATURE";
  EipError[EipError["NOT_NFT_OWNER"] = 10003] = "NOT_NFT_OWNER";
  EipError[EipError["CANNOT_STAKE_ZERO"] = 10006] = "CANNOT_STAKE_ZERO";
  EipError[EipError["EXPIRED_SIGNATURE"] = 10007] = "EXPIRED_SIGNATURE";
  EipError[EipError["STAKING_ID_EXISTS"] = 10008] = "STAKING_ID_EXISTS";
  EipError[EipError["NOT_SUFFICIENT_TOKEN"] = 10009] = "NOT_SUFFICIENT_TOKEN";
  EipError[EipError["NOT_APPROVED_SPEND_AMOUNT"] = 10010] = "NOT_APPROVED_SPEND_AMOUNT";
  EipError[EipError["STAKING_ID_NOT_EXISTS"] = 10011] = "STAKING_ID_NOT_EXISTS";
  EipError[EipError["NOT_STAKING_OWNER"] = 10012] = "NOT_STAKING_OWNER";
  EipError[EipError["STAKING_ID_UNSTUCK"] = 10013] = "STAKING_ID_UNSTUCK";
  EipError[EipError["NOT_TIME_UNLOCK"] = 10014] = "NOT_TIME_UNLOCK";
})(EipError || (EipError = {}));

export let WalletProvider;

(function (WalletProvider) {
  WalletProvider["METAMASK"] = "Metamask";
  WalletProvider["COINBASE"] = "Coinbase";
  WalletProvider["WALLET_CONNECT"] = "WalletConnect";
  WalletProvider["SEQUENCE"] = "Sequence";
  WalletProvider["THETAN_WALLET"] = "ThetanWallet";
})(WalletProvider || (WalletProvider = {}));

export let CosmeticType;

(function (CosmeticType) {
  CosmeticType[CosmeticType["AVATAR"] = 1] = "AVATAR";
  CosmeticType[CosmeticType["AVATAR_FRAME"] = 2] = "AVATAR_FRAME";
  CosmeticType[CosmeticType["EMOTE"] = 3] = "EMOTE";
  CosmeticType[CosmeticType["SPACESHIP"] = 4] = "SPACESHIP";
})(CosmeticType || (CosmeticType = {}));

export let NftItemRarity;

(function (NftItemRarity) {
  NftItemRarity[NftItemRarity["COMMON"] = 0] = "COMMON";
  NftItemRarity[NftItemRarity["EPIC"] = 1] = "EPIC";
  NftItemRarity[NftItemRarity["LEGENDARY"] = 2] = "LEGENDARY";
})(NftItemRarity || (NftItemRarity = {}));

export let CosmeticRarity;

(function (CosmeticRarity) {
  CosmeticRarity[CosmeticRarity["COMMON"] = 1] = "COMMON";
  CosmeticRarity[CosmeticRarity["EPIC"] = 2] = "EPIC";
  CosmeticRarity[CosmeticRarity["LEGENDARY"] = 3] = "LEGENDARY";
})(CosmeticRarity || (CosmeticRarity = {}));

export let CosmeticRefType; //Deprecated

(function (CosmeticRefType) {
  CosmeticRefType[CosmeticRefType["HERO"] = 0] = "HERO";
  CosmeticRefType[CosmeticRefType["PET"] = 1] = "PET";
  CosmeticRefType[CosmeticRefType["COSMETIC"] = 2] = "COSMETIC";
})(CosmeticRefType || (CosmeticRefType = {}));

export let BoxType;

(function (BoxType) {
  BoxType[BoxType["COMMON"] = 1] = "COMMON";
  BoxType[BoxType["EPIC"] = 2] = "EPIC";
  BoxType[BoxType["LEGENDARY"] = 3] = "LEGENDARY";
  BoxType[BoxType["SEASON"] = 4] = "SEASON";
  BoxType[BoxType["LUNAR"] = 5] = "LUNAR";
  BoxType[BoxType["SPECIAL"] = 6] = "SPECIAL";
})(BoxType || (BoxType = {}));

export const BoxTypeName = {
  [BoxType.COMMON]: 'Common',
  [BoxType.EPIC]: 'Epic',
  [BoxType.LEGENDARY]: 'Legendary',
  [BoxType.SEASON]: 'Season',
  [BoxType.LUNAR]: 'Lunar',
  [BoxType.SPECIAL]: 'Special'
};
export const currencyName = {
  [CurrencyType.BUSD]: 'BUSD',
  [CurrencyType.THC]: 'THC',
  [CurrencyType.THG]: 'THG',
  [CurrencyType.GTHG]: 'THG',
  [CurrencyType.GTHC]: 'THC',
  [CurrencyType.WBNB]: 'WBNB',
  [CurrencyType.GOLD]: 'GOLD',
  [CurrencyType.BNB]: 'BNB',
  [CurrencyType.GPP]: 'PP',
  [CurrencyType.BUSDT]: 'USDT',
  [CurrencyType.GPT]: 'GPT',
  [CurrencyType.GMQP]: 'GMQP'
};
export const itemName = {
  [ItemType.TOURNAMENT_TICKET]: 'Tournament Ticket'
};
export let NftSkinItemRarity;

(function (NftSkinItemRarity) {
  NftSkinItemRarity[NftSkinItemRarity["NORMAL"] = 0] = "NORMAL";
  NftSkinItemRarity[NftSkinItemRarity["RARE"] = 1] = "RARE";
  NftSkinItemRarity[NftSkinItemRarity["MYTHICAL"] = 2] = "MYTHICAL";
})(NftSkinItemRarity || (NftSkinItemRarity = {}));

export let BoxConfigRefType;

(function (BoxConfigRefType) {
  BoxConfigRefType[BoxConfigRefType["HERO_SKIN"] = 0] = "HERO_SKIN";
  BoxConfigRefType[BoxConfigRefType["PET"] = 1] = "PET";
  BoxConfigRefType[BoxConfigRefType["COSMETIC"] = 2] = "COSMETIC";
  BoxConfigRefType[BoxConfigRefType["CURRENCY"] = 3] = "CURRENCY";
})(BoxConfigRefType || (BoxConfigRefType = {}));

export let AdditionRewards;

(function (AdditionRewards) {
  AdditionRewards[AdditionRewards["GAME_PP"] = 2] = "GAME_PP";
  AdditionRewards[AdditionRewards["WHEEL_TICKET"] = 19] = "WHEEL_TICKET";
})(AdditionRewards || (AdditionRewards = {}));

export let CosmeticStatus;

(function (CosmeticStatus) {
  CosmeticStatus[CosmeticStatus["FREE"] = 1] = "FREE";
  CosmeticStatus[CosmeticStatus["MINTING"] = 2] = "MINTING";
  CosmeticStatus[CosmeticStatus["AVAILABLE"] = 3] = "AVAILABLE";
  CosmeticStatus[CosmeticStatus["USER_NOT_MINT"] = 7] = "USER_NOT_MINT";
  CosmeticStatus[CosmeticStatus["USER_MINTING"] = 8] = "USER_MINTING";
  CosmeticStatus[CosmeticStatus["SELLING"] = 20] = "SELLING";
  CosmeticStatus[CosmeticStatus["NOT_MINT"] = 31] = "NOT_MINT";
  CosmeticStatus[CosmeticStatus["PREPARE_SELLING"] = 110] = "PREPARE_SELLING";
  CosmeticStatus[CosmeticStatus["LOCK"] = 99] = "LOCK";
})(CosmeticStatus || (CosmeticStatus = {}));

export const currencyIconMap = {
  [CurrencyType.BUSD]: icBUSD,
  [CurrencyType.THC]: icThetanCoin,
  [CurrencyType.THG]: icThetanGem,
  [CurrencyType.WBNB]: icWBNB,
  [CurrencyType.BNB]: icBNB,
  [CurrencyType.GPP]: undefined,
  [CurrencyType.BUSDT]: icBUSDT,
  [CurrencyType.GTHG]: icThetanGem,
  [CurrencyType.GTHC]: icThetanCoin,
  [CurrencyType.GPT]: undefined,
  [CurrencyType.GOLD]: gold,
  [CurrencyType.GMQP]: icQuest
};
export const itemIconMap = {
  [ItemType.TOURNAMENT_TICKET]: icTournamentTicket
};
export let NftRefType;

(function (NftRefType) {
  NftRefType["HERO"] = "HERO";
})(NftRefType || (NftRefType = {}));

export let NtfHeroClassType;

(function (NtfHeroClassType) {
  NtfHeroClassType[NtfHeroClassType["TANK"] = 0] = "TANK";
  NtfHeroClassType[NtfHeroClassType["ASSASSIN"] = 1] = "ASSASSIN";
  NtfHeroClassType[NtfHeroClassType["MARKSMAN"] = 2] = "MARKSMAN";
})(NtfHeroClassType || (NtfHeroClassType = {}));

export let HeroStatus;

(function (HeroStatus) {
  HeroStatus[HeroStatus["DEFAULT"] = 0] = "DEFAULT";
  HeroStatus[HeroStatus["NOT_MINT"] = 1] = "NOT_MINT";
  HeroStatus[HeroStatus["MINTING"] = 2] = "MINTING";
  HeroStatus[HeroStatus["AVAILABLE"] = 3] = "AVAILABLE";
  HeroStatus[HeroStatus["RENTED"] = 4] = "RENTED";
  HeroStatus[HeroStatus["FUSING"] = 5] = "FUSING";
  HeroStatus[HeroStatus["HS_RENTED_RELEASED"] = 6] = "HS_RENTED_RELEASED";
  HeroStatus[HeroStatus["USER_NOT_MINT"] = 7] = "USER_NOT_MINT";
  HeroStatus[HeroStatus["USER_MINTING"] = 8] = "USER_MINTING";
  HeroStatus[HeroStatus["RENTED_OUT"] = -4] = "RENTED_OUT";
  HeroStatus[HeroStatus["ON_MARKET"] = 10] = "ON_MARKET";
  HeroStatus[HeroStatus["PREPARE_SELLING"] = 110] = "PREPARE_SELLING";
  HeroStatus[HeroStatus["PREPARE_LENDING"] = 111] = "PREPARE_LENDING";
  HeroStatus[HeroStatus["PREPARE_UNLOCKING"] = 112] = "PREPARE_UNLOCKING";
  HeroStatus[HeroStatus["FOR_RENT"] = 11] = "FOR_RENT";
  HeroStatus[HeroStatus["IN_TRANSACTION_PROCESS"] = 20] = "IN_TRANSACTION_PROCESS";
  HeroStatus[HeroStatus["LOCK"] = 99] = "LOCK";
  HeroStatus[HeroStatus["IN_STAKING"] = 30] = "IN_STAKING";
})(HeroStatus || (HeroStatus = {}));

export let GiftBoxType;

(function (GiftBoxType) {
  GiftBoxType[GiftBoxType["WELCOME"] = 11] = "WELCOME";
  GiftBoxType[GiftBoxType["GIFT"] = 12] = "GIFT";
  GiftBoxType[GiftBoxType["COINBASE"] = 13] = "COINBASE";
  GiftBoxType[GiftBoxType["QUEST"] = 14] = "QUEST";
  GiftBoxType[GiftBoxType["HOUSE"] = 16] = "HOUSE";
  GiftBoxType[GiftBoxType["HALLOWEEN"] = 17] = "HALLOWEEN";
  GiftBoxType[GiftBoxType["GLORYBOX"] = 20] = "GLORYBOX";
  GiftBoxType[GiftBoxType["SAMSUNG"] = 21] = "SAMSUNG";
  GiftBoxType[GiftBoxType["BIRTH_DAY"] = 24] = "BIRTH_DAY";
  GiftBoxType[GiftBoxType["SUMMER"] = 27] = "SUMMER";
})(GiftBoxType || (GiftBoxType = {}));

export let RouteName;

(function (RouteName) {
  RouteName["HomeDashboard"] = "/";
  RouteName["Dashboard"] = "/dashboard";
  RouteName["ThetanBox"] = "/thetanbox";
  RouteName["MarketPlace"] = "/buy";
  RouteName["Rental"] = "/rental";
  RouteName["Login"] = "/connect";
  RouteName["Profile"] = "/profile";
  RouteName["HeroDetail"] = "/item";
  RouteName["BuyThetanBox"] = "/thetanbox/buybox";
  RouteName["OpenThetanBox"] = "/open-thetanbox";
  RouteName["ClaimBoxHistory"] = "/profile/claimbox";
  RouteName["ConvertEvent"] = "/convert";
  RouteName["ConvertAction"] = "/convert/action";
  RouteName["CosmeticDetail"] = "/cosmetic";
  RouteName["LeaderBoard"] = "/special-event/leaderboard";
  RouteName["SpecialEventInfo"] = "/special-event/info";
  RouteName["Staking"] = "/staking";
  RouteName["YourStaking"] = "/staking/your-staking";
  RouteName["ProjectDetail"] = "/project";
  RouteName["VestingSafe"] = "/vesting-safe";
  RouteName["CreatorCorner"] = "/creator-corner";
  RouteName["MiniGame"] = "/minigame";
  RouteName["GiftBox"] = "/gift-box";
  RouteName["OpenGiftBox"] = "/gift-box/open";
  RouteName["SpecialEvent"] = "/special-event";
  RouteName["HeroFusion"] = "/special-event/hero-fusion";
  RouteName["DailyQuest"] = "/daily-quest";
  RouteName["CoinbaseLoot"] = "/special-event/coinbase-loot";
  RouteName["BundleBox"] = "/bundle-box";
  RouteName["TradingEvent"] = "/special-event/trading-event";
  RouteName["SamsungEvent"] = "/special-event/samsung-event";
  RouteName["GiftmasFortuneWheel"] = "/special-event/giftmas-fortune-wheel";
  RouteName["AllRoute"] = "*";
})(RouteName || (RouteName = {}));

export let UserStatus;

(function (UserStatus) {
  UserStatus[UserStatus["Active"] = 1] = "Active";
  UserStatus[UserStatus["Banned"] = -1] = "Banned";
})(UserStatus || (UserStatus = {}));